<template>
  <div>
    <Head title="Import Picklisted UIDs" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/pick-lists">Picklist Imports</Link>
      <span class="text-orange-400 font-medium">/</span> Upload
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="submit">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-8 pr-6 w-full">
            <label class="form-label">CSV File</label>
            <input type="file" @change="handleFile" accept=".csv" class="form-input w-full" />
            <div v-if="form.errors.csv" class="form-error">{{ form.errors.csv }}</div>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Import</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import LoadingButton from '@/Shared/LoadingButton';

export default {
  components: { Head, Link, LoadingButton },
  layout: Layout,
  data() {
    return {
      csvContent: '',
      form: this.$inertia.form({ csv: '' }),
    };
  },
  methods: {
    handleFile(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (ev) => { this.form.csv = ev.target.result; };
      reader.readAsText(file);
    },
    submit() {
      this.form.post('/picklist-uids/import');
    }
  }
};
</script>